import React, {useRef} from "react";
import {rootActions, useAppDispatch, useAppSelector} from "../../DAL/store";
import {ProductModel} from "../../interfaces";
import SbsEyeIcon from "../../icons/sbs-eye";

interface IPluginMobileProps {
    product : ProductModel;
    index: number;
}

export const PluginMobile = (props : IPluginMobileProps) => {

    const ShowPluginImageSortIncludesID = useAppSelector((store) => store.ShowPluginImageSortIncludesID);
    const dispatch = useAppDispatch();
    const eyeIconRef = useRef(null);
//console.log()
    const SetShowPluginImageSortIncludesID = (event:any) => {
        event.stopPropagation();
        if(eyeIconRef.current !== null){
            dispatch(
                rootActions.main({
                    ShowPluginImageSortIncludesID : props.product.sortIncludes,
                })
            )
        }
        return false;
    }

    return (
        <li key={props.index} className="w-full flex items-center py-3" style={{borderTop:"1px solid #384352"}}>
            <button type={"button"} className="flex items-center justify-center relative z-50 cursor-pointer" style={{width:"32px"}}
                    onClick={SetShowPluginImageSortIncludesID}
                    ref={eyeIconRef}
                    aria-label={`Info popup button for ${props.product.documentName}`}
            >
                <SbsEyeIcon
                    width="22px"
                    color={ ShowPluginImageSortIncludesID === props.product.sortIncludes ? "white" : undefined}
                    title="View Plugin Image "
                />

            </button>
            <div className="pl-1 flex-1 text-tiny" >{props.product.documentName}{props.product.skuInStoreFrom && props.product.skuInStoreFrom !== '' &&<span className="text-yellow-400"> - NEW</span> }</div>
{/*
            <div className="flex items-center justify-center" style={{width:"50px"}}>{showCheck ? <CheckIcon width={"15px"} color={"white"} /> : <></> }</div>
*/}

        </li>
    )
};